import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ad3febdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu_name" }
const _hoisted_2 = { class: "menu_name" }

import MenuItem from './menu_item.vue'
import { PropType, watch, ref, computed } from 'vue' 
import { useRoute,useRouter } from 'vue-router'
import { useStore } from 'vuex';
import KlIcon from '@/components/icon-picker/KLIcon.vue'
import { getGoodsShop } from "@/api/Kilimall/seller";
import { getApiConfig } from "@/utils/request";
export interface MenuModel {
    name: string,
    icon: string,
    type: number,
    meta?: any,
    store_id?: Array<number>,
    children: Array<MenuModel>
}

export default /*#__PURE__*/_defineComponent({
  props: {
  menu_item: {
    type: Object as PropType<MenuModel>,
    required: true,
  },
  key_name: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props

const storeInfo = ref(localStorage.getItem('StoreInfo') ? JSON.parse(localStorage.getItem('StoreInfo')) : {})

const store = useStore();


const msgTotal = computed(() => store.state.user.messageCount)
const router:any = useRouter()
const route: any = useRoute()
const menu_item = ref(props.menu_item)
if(storeInfo && storeInfo.value && menu_item && menu_item.value && menu_item.value.store_id) {
  if(!menu_item.value.store_id.includes(storeInfo.value.store_id)) menu_item.value.meta.disabled = true
}
const keyname = props.key_name
 
const language = computed(() => {
  return store.getters.language
})

let token = computed(()=>{
        return store.getters.token
      })
  
 const api_config = getApiConfig();
   

watch(() => props.menu_item, (v)=> {
  menu_item.value = v
})

const fn_router_jump = (item: any) => {
    switch(item.type) {
    case 1:
      router.push(item.path)   
      break;
    case 2:
      getGoodsShop() // 增加一个临时接口调用解决进入php内部token过期401登录的问题
      router.push(`/iframe?u=${encodeURIComponent(item.path)}&tcn=${encodeURIComponent(item.meta.title)}&ten=${encodeURIComponent(item.meta.title_en)}`)
      setTimeout(() => {
        store.dispatch('addVisitedViews',route)
      }, 300);
      let params = {
          path:item.path,
          meta:item.meta
      } 
      route.meta = item.meta
      break;
    case 3:
     window.open(`${api_config.jumpUrl}/${item.path}?token=${token.value}&lang=${language.value}`)  
      break;
    default:
      window.open(item.path)
      break
  }
  
}

return (_ctx: any,_cache: any) => {
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!

  return (menu_item.value.children && menu_item.value.children.length > 0)
    ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 0,
        class: "menu_icon",
        index: _unref(keyname)
      }, {
        title: _withCtx(() => [
          _createVNode(KlIcon, {
            size: "18",
            icon: menu_item.value.icon
          }, null, 8, ["icon"]),
          _createVNode(_component_el_badge, {
            hidden: menu_item.value.name!=='服务' || _unref(msgTotal) <= 0,
            value: _unref(msgTotal),
            max: 99,
            class: "item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(language) === 'en' ?  menu_item.value.meta.title_en : menu_item.value.meta.title), 1)
            ]),
            _: 1
          }, 8, ["hidden", "value"])
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menu_item.value.children, (item, index) => {
            return (_openBlock(), _createBlock(MenuItem, {
              key: _unref(keyname) + '-' + index,
              menu_item: item,
              key_name: _unref(keyname) + '-' + index
            }, null, 8, ["menu_item", "key_name"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["index"]))
    : (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 1,
        class: "menu_icon",
        index: _unref(keyname),
        disabled: menu_item.value.meta ? menu_item.value.meta.disabled : false,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (fn_router_jump(menu_item.value)))
      }, {
        default: _withCtx(() => [
          _createVNode(KlIcon, {
            size: "18",
            icon: menu_item.value.icon
          }, null, 8, ["icon"]),
          _createVNode(_component_el_badge, {
            hidden: menu_item.value.name!=='客户聊天' || _unref(msgTotal) <= 0,
            value: _unref(msgTotal),
            max: 99,
            class: "item"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(language) === 'en' ?  menu_item.value.meta.title_en : menu_item.value.meta.title), 1)
            ]),
            _: 1
          }, 8, ["hidden", "value"])
        ]),
        _: 1
      }, 8, ["index", "disabled"]))
}
}

})